import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    data: null,
    loading: false,
    error: null
};
const familyFestDashboardChartsSlice = createSlice({
    name: 'familyFestDashboardCharts',
    initialState,
    reducers: {
        fetchChartsStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchChartsSuccess(state, action) {
            state.data = action.payload;
            state.loading = false;
            state.error = null;
        },
        fetchChartsFailure(state, action) {
            state.loading = false;
            state.error = action.payload;
        }
    }
});
export const { fetchChartsStart, fetchChartsSuccess, fetchChartsFailure } = familyFestDashboardChartsSlice.actions;
export default familyFestDashboardChartsSlice.reducer;
